import { type StoreGroupsFormProps } from 'legacy/sections/store-groups/components/form/StoreGroupsForm'
import { useCreateStoreGroup } from 'legacy/sections/store-groups/graphql/create.hooks'

export const useCreateStoreGroupOnSubmit = () => {
  const { createStoreGroup, createdStoreGroup, loading, error } = useCreateStoreGroup()

  const handleSubmit: StoreGroupsFormProps['handleSubmit'] = ({
    name,
    selectedLocationIds: retailerLocationIds,
  }) => {
    createStoreGroup({
      name,
      retailerLocationIds,
    })
  }

  return {
    handleSubmit,
    createdStoreGroup,
    loading,
    error,
  }
}
